<div class="blast-holes" [class.blast-holes--mobile]="device.isMobile()" data-attr="blast-holes">

  <!-- ── Toolbar : view radios | planning · search · import holes ─────────────── -->
  <header class="blast-holes__toolbar">
    <app-radiobox
      class="blast-holes__views"
      size="small"
      [options]="viewOptions()"
      [ngModel]="view()"
      (ngModelChange)="onViewChange($event)"
      data-attr="holes-view-switch">
    </app-radiobox>

    <div class="blast-holes__actions">
      <app-button
        variant="tertiary"
        size="small"
        [label]="'HOLES_TAB.PLANNING' | translate"
        data-attr="holes-planning-btn"
        (clicked)="onPlanning()">
      </app-button>

      <app-input
        class="blast-holes__search"
        type="search"
        [placeholder]="'HOLES_TAB.SEARCH' | translate"
        [clearable]="true"
        [ngModel]="state.searchTerm()"
        (ngModelChange)="onSearchChange($event)"
        data-attr="holes-search">
        <img slot="icon-left" src="assets/icon/new_icon/search.svg" alt="">
      </app-input>

      <app-button
        variant="primary"
        size="small"
        [label]="'GLOBAL.IMPORT_HOLES' | translate"
        [addIconLeft]="true"
        data-attr="holes-import-btn"
        (clicked)="onImportHoles()">
        <i slot="icon-left" class="fas fa-file-import"></i>
      </app-button>
    </div>
  </header>

  <!-- ── Body : legend | map | splitter | panel (grid areas) ───────────────── -->
  <div class="blast-holes__body" #body
    [class.blast-holes__body--no-legend]="!hasLegend()"
    [style.--holes-map-share]="mapShare()"
    [style.--holes-map-min]="MAP_MIN_REM + 'rem'"
    [style.--holes-panel-min]="PANEL_MIN_REM + 'rem'">
    <app-blast-holes-map class="blast-holes__map" #mapHost />

    <!-- Drag (or arrow keys) to trade map width for table width; double-click restores the default split. -->
    <div class="blast-holes__splitter"
      [class.blast-holes__splitter--active]="splitterActive()"
      role="separator"
      aria-orientation="vertical"
      tabindex="0"
      [attr.aria-label]="'HOLES_TAB.RESIZE_PANES' | translate"
      [attr.aria-valuenow]="mapSharePercent()"
      aria-valuemin="0"
      aria-valuemax="100"
      data-attr="holes-splitter"
      (pointerdown)="onSplitterDown($event)"
      (pointermove)="onSplitterMove($event)"
      (pointerup)="onSplitterUp()"
      (pointercancel)="onSplitterUp()"
      (lostpointercapture)="onSplitterUp()"
      (dblclick)="resetSplit()"
      (keydown)="onSplitterKey($event)">
    </div>

    <!-- Each view renders its own legend + panel cells (host is display: contents). -->
    @switch (view()) {
      @case ('state') {
        <app-holes-state-view />
      }
      @case ('geology') {
        <app-holes-geology-view />
      }
      @case ('quality') {
        <app-holes-quality-view />
      }
      @case ('drilling') {
        <app-holes-drilling-view />
      }
      @case ('delivery') {
        <app-holes-delivery-view />
      }
      @default {
        <app-holes-view-placeholder [view]="view()" [hasLegend]="hasLegend()" />
      }
    }
  </div>

  <app-csv-hole-import-modal
    [isOpen]="importOpen()"
    [blastId]="state.blastId()!"
    [blastName]="state.blast()?.nom ?? ''"
    [plannedHoleCount]="state.holes().length"
    [siteEpsg]="siteEpsg()"
    (imported)="onHolesImported()"
    (closed)="onImportClosed()" />

</div>
